/**
 * @typedef {Object} Review
 * @property {string} id    Stable key.
 * @property {string} name  Customer (patient) name shown under the quote.
 * @property {string} quote Review text, shown verbatim.
 * @property {string} image Path relative to public/.
 */

/** @type {Review[]} */
export const REVIEWS = [
  {
    id: 'lucas',
    name: 'Lucas',
    quote: 'Totally happy with the special care and treatment from the vets.',
    image: 'images/reviews/1.png',
  },
  {
    id: 'ah-ju',
    name: 'Ah Ju',
    quote: 'Awesome spa experience and I smelled great after the bath.',
    image: 'images/reviews/2.png',
  },
  {
    id: 'carrot',
    name: 'Carrot',
    quote: 'This is my home, I feel so comfortable.',
    image: 'images/reviews/3.png',
  },
];
